import React from 'react';
import { Link } from 'react-router-dom'; // Ha a react-router-dom-ot használod
import '../styles/components/BackButton.css'

const BackButton = ({ to }) => {
  return (
    <div className='back-button-container'>
      <Link className="back-button-page" to={to}>vissza az előző oldalra</Link>
    </div>
  );
}

export default BackButton;
